import {useState, useCallback} from 'react';

export default function useLocalStorage(key, defaultValue){
  if(defaultValue === null){
    throw new Error("null is an invalid default value");
  }
  let knownValue = JSON.parse(localStorage.getItem(key))
  if(knownValue === null){
    knownValue = defaultValue;
  }
  const [value, _setValue] = useState(knownValue);
  const setValue = useCallback((newValue) => {
    localStorage.setItem(key, JSON.stringify(newValue));
    _setValue(newValue);
  }, [key]);
  return [value, setValue];
}
